import { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { Title, Text } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const ConfirmationDialog = _ref => {
  let {
    open,
    variant = 'primary',
    title,
    text,
    mainActionLabel = 'Confirm',
    secondaryActionLabel = 'Cancel',
    confirmAction,
    onClose,
    ignoreConfirmationLoading = false,
    dataTestid = 'confirmation-dialog',
    sx
  } = _ref;
  const [isLoading, setIsLoading] = useState(false);
  const onConfirmationClick = async () => {
    try {
      setIsLoading(true);
      await confirmAction();
    } finally {
      setIsLoading(false);
    }
  };
  return /*#__PURE__*/jsxs(Dialog, {
    open: open,
    onClose: onClose,
    maxWidth: "xs",
    fullWidth: true,
    "data-testid": `${dataTestid}-dialog`,
    sx: sx,
    children: [/*#__PURE__*/jsx(DialogTitle, {
      children: /*#__PURE__*/jsx(Title, {
        "data-testid": "dialog-title",
        variant: variant,
        children: title
      })
    }), /*#__PURE__*/jsx(DialogContent, {
      children: /*#__PURE__*/jsx(Text, {
        "data-testid": "dialog-text",
        children: text
      })
    }), /*#__PURE__*/jsxs(DialogActions, {
      children: [/*#__PURE__*/jsx(Button, {
        color: "secondary",
        onClick: onClose,
        "data-testid": `${dataTestid}-secondary-action-button`,
        disabled: ignoreConfirmationLoading ? undefined : isLoading,
        children: secondaryActionLabel
      }), /*#__PURE__*/jsx(Button, {
        color: variant === 'destructive' ? 'error' : variant,
        onClick: onConfirmationClick,
        "data-testid": `${dataTestid}-main-action-button`,
        loading: ignoreConfirmationLoading ? undefined : isLoading,
        disabled: ignoreConfirmationLoading ? undefined : isLoading,
        children: mainActionLabel
      })]
    })]
  });
};

export { ConfirmationDialog };
